import { CallApi } from '@signavio/kraken'

import { schema } from './workflow'

export { collection, schema } from './workflow'

type CreateQueryType = {
  id: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: CreateQueryType) =>
    callApi(`${apiBase}/workflows/${id}/copy`, schema, {
      method: 'POST',
    })
